


























import {Prop, Watch} from "vue-property-decorator";
	import {Component, Vue} from '@/shared/component';

	import {storeEssenceAchatsRecherche, EssenceAchatFilter} from '@/stores/modules/essenceAchat';
	
	import CrudList from '@/components/Crud/List.vue';
	import TableHead from '@/components/Paginate/TableHead.vue';
	import TableCell from '@/components/Paginate/TableCell.vue';
	import Checked from '@/components/Checked.vue';
	import {Stored} from "vue-stored-prop-decorator/index";
	import {WatchObjectProperties} from "@/shared/decorator";
	import {FournisseurFilter} from "@/stores/modules/fournisseur";
	
	@Component({
		components: {
			CrudList,
			TableHead,
			TableCell,
			Checked,
		}
	})
	export default class CrudEssenceAchatListRechercheEssenceAchats extends Vue {
		
		@Prop({type: Boolean, default: true  }) private paginate;
		@Prop({type: Boolean, default: false }) private dense;
		
		private storeEssenceAchatsRecherche = storeEssenceAchatsRecherche;

	}
